import { Appointment, AppointmentType } from '@generated/gql/graphql';
import { INTRODUCED_BY, ReferralFieldFormValues } from '@src/types/attribution';
import { BooleanSelection } from '@src/types/index';

export const SUPPORT_REMOTE = 'support-remote' as const;
export const GETTING_QUOTE = 'getting-quote' as const;
type PartnerAppointmentType =
  | AppointmentType
  | typeof SUPPORT_REMOTE
  | typeof GETTING_QUOTE;

export interface Option {
  label: string;
  value: string;
}

export interface PartnerFormValues extends ReferralFieldFormValues {
  appointmentType: PartnerAppointmentType;
  hasSupportingPartner: BooleanSelection;
  supportingPartnerType: AppointmentType;
  supportingPartnerEmail: string;
  supportingPartnerPassword: string;
  restoreQuote: BooleanSelection;
  restoredQuoteAlreadyAttributed: boolean;
  restoreQuoteAddress?: Option;
  restoreQuoteSelection?: string;
}

export const initialValues: PartnerFormValues = {
  appointmentType: AppointmentType.FaceToFace,
  introducedBy: INTRODUCED_BY.NONE,
  customerReferral: '',
  connectorReferral: '',
  hasSupportingPartner: BooleanSelection.No,
  supportingPartnerType: AppointmentType.FaceToFace,
  supportingPartnerEmail: '',
  supportingPartnerPassword: '',
  restoreQuote: BooleanSelection.No,
  restoredQuoteAlreadyAttributed: false,
  restoreQuoteAddress: undefined,
  restoreQuoteSelection: '',
};

export interface SupportRemoteAppointmentResult {
  data: {
    supportRemoteAppointment: {
      appointment: Appointment;
    };
  };
  errors: [
    {
      message: string;
    },
  ];
}
